import { Asterisk } from "lucide-react";

const ITEMS = [
  "Måleri",
  "Fasad",
  "Renovering",
  "Tapetsering",
  "Mosaik/Sockelputs",
  "Eskilstuna med omnejd",
  "Måleri",
  "Fasad",
  "Renovering",
  "Tapetsering",
  "Mosaik/Sockelputs",
  "Eskilstuna med omnejd",
];

export const Marquee = () => {
  return (
    <div
      data-testid="marquee"
      className="bg-[#D92525] border-y-2 border-[#0B132B] overflow-hidden py-5"
    >
      <div className="flex marquee-track whitespace-nowrap">
        {[...ITEMS, ...ITEMS].map((it, i) => (
          <div
            key={i}
            className="flex items-center gap-6 px-6 font-display font-black text-white text-2xl md:text-3xl tracking-tight"
          >
            <span>{it}</span>
            <Asterisk size={22} strokeWidth={3} />
          </div>
        ))}
      </div>
    </div>
  );
};
